module.exports = __webpack_public_path__ + "static/media/portfolio2.e0ddfc0f.jpg";